import Mail from '@material-ui/icons/Mail'
import InvitationList from './InvitationList'

const invitations = (permissions) => ({
  icon: Mail,
  list: permissions.includes('read:users') ? InvitationList : undefined,
  name: 'invitations',
})

export default invitations
